import { render } from "./SuperUser.vue?vue&type=template&id=0de0a018&scoped=true"
import script from "./SuperUser.vue?vue&type=script&lang=js"
export * from "./SuperUser.vue?vue&type=script&lang=js"

import "./SuperUser.vue?vue&type=style&index=0&id=0de0a018&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de0a018"]])

export default __exports__